var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "results-analysis" }, [
    _c(
      "div",
      {
        staticClass: "flex-column items-center justify-center",
        staticStyle: { width: "1080px", padding: "40px 0 65px" },
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "title-message" }, [
          _vm._v("上传技术成果，帮您深度解析技术优劣势"),
        ]),
        _c("div", { staticClass: "content-bg" }, [
          _c("div", { staticClass: "content-box" }, [
            _c(
              "div",
              { staticClass: "input-content" },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    resize: "none",
                    placeholder:
                      "您可以在这里描述您的成果，例如：\n成果面向产业方向是：xxx；\n主要解决问题是：xxx；\n成果方案描述：xxx；\n请推荐几家潜在的可以合作的机构。",
                  },
                  model: {
                    value: _vm.textarea,
                    callback: function ($$v) {
                      _vm.textarea = $$v
                    },
                    expression: "textarea",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "upload-file" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo",
                    attrs: {
                      drag: "",
                      action: "null",
                      multiple: false,
                      "show-file-list": false,
                      "auto-upload": false,
                      "on-change": _vm.handleFileChange,
                      accept: ".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx",
                    },
                  },
                  [
                    !_vm.uploadFile
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex-column items-center justify-center",
                            staticStyle: { height: "100%" },
                          },
                          [
                            _c("img", {
                              attrs: {
                                width: "40",
                                height: "32",
                                src: _vm.uploadIcon,
                                alt: "",
                              },
                            }),
                            _c("div", { staticClass: "upload_text" }, [
                              _vm._v("AI文档解析，"),
                              _c("span", [_vm._v("点击上传")]),
                            ]),
                            _c("div", { staticClass: "upload-line" }, [
                              _c("div"),
                              _vm._v("上传格式"),
                              _c("div"),
                            ]),
                            _c("div", { staticClass: "flex justify-center" }, [
                              _c("div", { staticClass: "upload-img" }, [
                                _c("img", {
                                  attrs: {
                                    width: "24",
                                    height: "22",
                                    src: _vm.word,
                                    alt: "",
                                  },
                                }),
                                _c("img", {
                                  attrs: {
                                    width: "24",
                                    height: "22",
                                    src: _vm.excel,
                                    alt: "",
                                  },
                                }),
                                _c("img", {
                                  attrs: {
                                    width: "22",
                                    height: "22",
                                    src: _vm.ppt,
                                    alt: "",
                                  },
                                }),
                                _c("img", {
                                  attrs: {
                                    width: "22",
                                    height: "22",
                                    src: _vm.pdf,
                                    alt: "",
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "flex-column items-center justify-center show-file",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex-column items-center",
                                staticStyle: { cursor: "default" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return (() => {}).apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    width: "44",
                                    height: "46",
                                    src: _vm.fileType,
                                    alt: "",
                                  },
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "overflow overflow-2 file-name",
                                  },
                                  [_vm._v(_vm._s(_vm.uploadFile.name))]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "operation-btn" }, [
                              _c("span", [_vm._v("重新上传")]),
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteFile.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]),
                          ]
                        ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "upload-btn" },
          [
            _c(
              "el-button",
              {
                attrs: { loading: _vm.loading },
                on: { click: _vm.handleSubmit },
              },
              [_vm._v("立即识别")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-box" }, [
      _c("div", { staticClass: "ai-icon" }),
      _c("div", { staticClass: "title-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }